/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

export type CategoryID = string;

export class Category {
	properties: Array<string> = []
}